<template>
  <v-card class="py-2">
    <v-icon v-on:click.stop="$emit('close')" large class="closeIcon mt-3 mx-2"
      >mdi-close</v-icon
    >
    <h2
      weight="200"
      class="mt-6 d-flex font-weight-regular justify-center align-center"
    >
      Importer (.zip)
    </h2>
    <v-divider light color="#EF7D00" class="mt-4 mb-6 mx-4"></v-divider>
    <v-form
      ref="form"
      v-model="isFormValid"
      class="d-flex flex-column px-10 py-4"
    >
      <v-file-input
        v-model="media"
        accept=".zip"
        show-size
        :label="`Importer le fichier compressé (.zip) | Max : ${this.maxSize} Go`"
        :rules="media_rule"
        class="no-truncate"
      ></v-file-input>
    </v-form>
    <ValidateErrorButtons
      @successClicked="validate"
      @errorClicked="closeDialog"
      :disabled="!isFormValid"
    >
      <template v-slot:error>ANNULER</template>
      <template v-slot:success>VALIDER</template>
    </ValidateErrorButtons>
  </v-card>
</template>

<script>
import ValidateErrorButtons from "../../components/ValidateErrorButtons.vue";

export default {
  name: "DialogImport",
  components: {
    ValidateErrorButtons,
  },
  props: {
    directoryId: String,
  },
  data: () => ({
    isFormValid: false,
    media: null,
    maxSize: 5, // en Go
  }),
  computed: {
    media_rule: function () {
      return [
        !!this.media || "Vous devez importer un fichier zip",
        this.media?.size <= this.maxSize * 1024 * 1024 * 1024 ||
          `Le fichier ne peut pas dépasser ${this.maxSize} Go`,
      ];
    },
  },
  methods: {
    validate: function () {
      this.$refs.form.validate();
      if (!this.isFormValid) return;
      if (!this.directoryId) {
        console.error("directoryId is missing, cannot import.");
        return;
      }

      const formData = new FormData();
      formData.append("file", this.media);

      this.$store
        .dispatch("leodata/import", {
          directoryId: this.directoryId,
          formData,
        })
        .then(() => {
          this.closeDialog();
        });
    },
    closeDialog() {
      this.$emit("close");
    },
    initializeForm() {
      this.media = null;
    },
  },
  created() {
    this.initializeForm();
  },
  watch: {
    directoryId(newValue) {
      if (newValue) {
        this.initializeForm();
      }
    },
  },
};
</script>
<style scoped>
.v-sheet {
  position: relative;
  color: #8f8f8f;
}
.v-icon,
.v-input {
  color: #8f8f8f;
}
.closeIcon {
  position: absolute;
  right: 0;
  top: 0;
}

.no-truncate .v-file-input__text {
  color: red;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}
</style>
